import { logEvent } from '@eventbrite/statsig';
import React from 'react';
import { connect } from 'react-redux';
import { Carousel, CarouselCard } from '../../../../../../components/Carousel';
import { DiscoverState, SuggestedCategory } from '../../../../../../types';
import { capitalizeWords } from '../../../../../../utils/general';
import { CATEGORY_CONTENT_MAP } from '../../../../../categoryBrowse/constants';
import { generateBrowsePath } from '../../../../../categoryBrowse/utils/url';
import { STATSIG_EVENT_CLICK_CAROUSEL } from '../../../../../home/constants/analytics';
import './SuggestedCategories.scss';

interface SuggestedCategoriesProps {
    suggestedCategories: SuggestedCategory[];
    locationSlug?: string;
}

export const SuggestedCategories: React.FunctionComponent<
    SuggestedCategoriesProps
> = (props) => {
    const { suggestedCategories, locationSlug } = props;
    const handleCategoryClick = () => {
        logEvent(STATSIG_EVENT_CLICK_CAROUSEL);
    };

    return (
        <div
            className="suggested-categories-container"
            data-testid="suggested-categories"
        >
            <Carousel
                cards={suggestedCategories}
                justifyContentValue="flex-start"
            >
                {(suggestedCategory) => {
                    return (
                        <a
                            href={generateBrowsePath(
                                suggestedCategory?.id,
                                locationSlug,
                            )}
                            onClick={handleCategoryClick}
                            key={suggestedCategory?.id}
                            data-testid="suggested-category-link"
                        >
                            <CarouselCard
                                title={capitalizeWords(
                                    suggestedCategory?.name || '',
                                )}
                                imageUrl={
                                    CATEGORY_CONTENT_MAP[
                                        suggestedCategory?.id || ''
                                    ].imageUrlSmall
                                }
                                imageLoading={'lazy'}
                            />
                        </a>
                    );
                }}
            </Carousel>
        </div>
    );
};

const _mapStateToProps = (state: DiscoverState) => ({
    suggestedCategories: state.search.suggestedCategories,
    locationSlug: state.location.slug,
});

export const SuggestedCategoriesContainer =
    connect(_mapStateToProps)(SuggestedCategories);
